import React from 'react';
import { Link } from 'react-router-dom';
import { Award } from 'lucide-react';
import { Badge } from './ui/badge';

export default function PublicFooter() {
  return (
    <footer className="bg-slate-900 text-white py-12" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Provider Banner */}
        <div className="bg-slate-800/50 rounded-lg p-4 mb-8 border border-slate-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-sky-600 rounded-lg flex items-center justify-center shrink-0">
                <Award className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-sm font-medium text-white">
                  Courses provided by Preferred Systems
                </p>
                <p className="text-xs text-slate-400">
                  TREC Approved Provider #9980 | Licensed in 47 states
                </p>
              </div>
            </div>
            <Badge className="bg-emerald-600/20 text-emerald-400 border border-emerald-600/30 px-3">
              TREC Approved
            </Badge>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                DealLab CE
              </span>
            </div>
            <p className="text-slate-400 text-sm">
              Professional continuing education for Texas real estate agents.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/public/courses" className="hover:text-white transition-colors">Courses</Link></li>
              <li><Link to="/public/schedule" className="hover:text-white transition-colors">Schedule</Link></li>
              <li><Link to="/public/instructors" className="hover:text-white transition-colors">Instructors</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-slate-400">
              <li><Link to="/public/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/public/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/public/request" className="hover:text-white transition-colors">Book for Your Team</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>info@deallabce.com</li>
              <li>(281) 900-5687</li>
              <li>Texas, USA</li>
            </ul>
          </div>
        </div>
        
        {/* Bottom section with copyright and Powered By */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Copyright and Admin Link */}
            <div className="flex flex-col sm:flex-row items-center gap-4 text-slate-400 text-sm">
              <p>&copy; {new Date().getFullYear()} DealLab CE. All rights reserved. TREC Provider.</p>
              <Link to="/admin/login" className="text-slate-500 hover:text-slate-300 transition-colors text-xs">
                Instructor/Admin Login
              </Link>
            </div>
            
            {/* Powered By Section */}
            <div className="flex items-center gap-2" data-testid="powered-by-section">
              <span className="text-slate-500 text-xs">Powered by</span>
              <img 
                src="/images/psi-logo.png" 
                alt="Preferred Systems Inc." 
                className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity"
                data-testid="powered-by-logo"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
